"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProductsContainer = exports.StyledTabsContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTabsContainer = styled_components_1.default.div `
  display: grid;
  grid-template-columns: minmax(230px, 1fr);
  grid-auto-flow: column;
  grid-auto-columns: 2fr;
  overflow: hidden;
  flex: 1;
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.StyledProductsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  flex: 1;
`;
